import { PaymentReport } from 'app/modules/ManagementReport/PaymentReport';
import { TaxpayerReport } from 'app/modules/ManagementReport/TaxpayerReport/Loadable';
import { TaxreturnReport } from 'app/modules/ManagementReport/TaxreturnReport/Loadable';
import { Route, Routes } from 'react-router-dom';

import RouteAuth from '../../core/security/routeAuth';
import { Role } from '../Security/models/Authorization';

export const ManagementReportRouting = () => {
  return (
    <Routes>
      <Route
        path="taxpayer"
        element={
          <RouteAuth access={[Role.ManagementReportAdmin]}>
            <TaxpayerReport />
          </RouteAuth>
        }
      />
      <Route
        path="taxreturn"
        element={
          <RouteAuth access={[Role.ManagementReportAdmin]}>
            <TaxreturnReport />
          </RouteAuth>
        }
      />
      <Route
        path="payment"
        element={
          <RouteAuth access={[Role.ManagementReportAdmin]}>
            <PaymentReport />
          </RouteAuth>
        }
      />
    </Routes>
  );
};
